import React, {Component} from 'react'
import {connect} from 'react-redux'
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import ProductItem from "../../common/product-item";
import store, {history} from '../../../../../store'
import ConfirmPopup from "../../../../common/confirm-popup";
import {deleteCategory, reorderCategories} from '../../../../../actions/categories'

const CategoryItem = SortableElement(({item, onDelete, onEdit}) =>
  <ProductItem item={item}
               itemType="Category"
               status={item.attributes["category-status"]}
               deleteDisabled={item.attributes["category-status"] !== 'DRAFT'}
               onDelete={onDelete}
               onEdit={onEdit}/>
);

const CategoriesContainer = SortableContainer(({items, onDelete, onEdit}) => {
  return (
    <div>
      {items.map((value, index) => (
        <CategoryItem key={`item-${value.id}`}
                      index={index}
                      item={value}
                      onDelete={onDelete}
                      onEdit={onEdit}/>
      ))}
    </div>
  );
});

class CategoriesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  toggleDeletePopup = (id) => {
    this.setState({delete: {show: !this.state.delete.show, id: id}});
  };

  handleDelete = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if (result) {
      store.dispatch(deleteCategory(id));
    }
  };

  handleEdit = (id) => {
    history.push(`/admin/categories/${id}`);
  };

  handleSort = ({oldIndex, newIndex}) => {
    if(oldIndex !== newIndex){
      const newOrdering = arrayMove(this.props.categories, oldIndex, newIndex);
      store.dispatch(reorderCategories(newOrdering));
    }
  };

  render() {
    return (
      <div>
        <CategoriesContainer items={this.props.categories}
                             lockAxis="y"
                             pressDelay={150}
                             helperClass="product-reordering"
                             onDelete={this.toggleDeletePopup}
                             onEdit={this.handleEdit}
                             onSortEnd={this.handleSort}/>

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE CATEGORY?"
                        onClose={this.handleDelete}>
            <p>Are you sure you want to delete the selected category?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

export default CategoriesList


// WEBPACK FOOTER //
// ./src/components/admin/products/categories/list/categories-list.jsx